// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/design-system/components/actions/ActionGroup.jsx

import React from "react";
import Button from "./Button";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function ActionGroup({
  actions = [],
  children = null,
  align = "start",
  density = "default",
  className = "",
}) {
  const visibleActions = (Array.isArray(actions) ? actions : []).filter(Boolean);
  const hasChildren = React.Children.count(children) > 0;

  if (visibleActions.length === 0 && !hasChildren) return null;

  return (
    <div
      className={joinClassNames(
        "oasys-action-group",
        `oasys-action-group--${align}`,
        `oasys-action-group--${density}`,
        className
      )}
    >
      {visibleActions.map((action, index) => (
        <Button
          key={action.key || action.label || `action-${index}`}
          ref={action.buttonRef}
          variant={action.variant || "secondary"}
          size={action.size || "medium"}
          loading={Boolean(action.loading)}
          loadingLabel={action.loadingLabel}
          disabled={Boolean(action.disabled)}
          fullWidth={Boolean(action.fullWidth)}
          iconBefore={action.iconBefore}
          iconAfter={action.iconAfter}
          className={action.className || ""}
          style={action.style}
          onClick={action.onClick}
          type={action.type || "button"}
          aria-label={action.ariaLabel}
          title={action.title}
        >
          {action.label}
        </Button>
      ))}

      {children}
    </div>
  );
}
